// extracted by mini-css-extract-plugin
module.exports = {"share":"style_share__QhI8o","share-text":"style_share-text__yo10g","share-icon":"style_share-icon__b3tU3"};